import React from "react";
import { StringHelper } from "../../../common/Helpers";
import RestClient from "../../../common/RestClient";
import { BaseListing } from "../../common/BaseListing";
import _ from "lodash";
import {
  NavigationItem,
  NavigationSettings,
} from "../../common/NavigationSettings";
import { RefundStatus } from "../../../constants/RefundConstants";
import { ApplicationID } from "../../../common/Constants";

export class RefundListing extends BaseListing {
  constructor() {
    super();
    this.state = {
      statistic: {
        approved: 0,
        pending: 0,
        processed: 0,
        rejected: 0,
        submitted: 0,
        successful: 0,
      },
    };
    this.selectedStatuses = [];
    this.searchText = "";
  }

  getNavigationSettings = () => {
    return new NavigationSettings({
      parentModule: new NavigationItem({
        identifier: "transactions",
        name: "Transaction Management",
      }),
      activeModule: new NavigationItem({
        identifier: "refunds",
        name: "Refunds",
      }),
    });
  };

  getApiPath = () => "/api/v1/refunds";

  getDefaultSort = () => "-CreatedOn";

  generateTableContent() {
    const { data } = this.state;
    return (
      <>
        <thead>
          <tr>
            <th>Transaction Number</th>
            <th>Transaction Mode</th>
            <th>Amount</th>
            <th>Requested By</th>
            <th>Status</th>
            <th onClick={this.onColumnClick}>
              Last Updated On{" "}
              <i
                className="sort-button fas fa-sort-alpha-down"
                id="UpdatedOn"
                onClick={this.toggleSort}
              />
            </th>
            <th onClick={this.onColumnClick}>
              Created On
              <i
                className="sort-button fas fa-sort-alpha-down"
                id="CreatedOn"
                onClick={this.toggleSort}
              />
            </th>
          </tr>
        </thead>
        <tbody>
          {data &&
            data.map((item, index) => (
              <tr key={index} onClick={(e) => this.onRowClick(item.id)}>
                <td>{item.transactionReferenceNumber}</td>
                <td>{ApplicationID.getName(item.appId)}</td>
                <td>${item.amount ? item.amount.toFixed(6) : ""}</td>
                <td>{item.createdBy}</td>
                <td>
                  <span className={this.getStatusStyle(item.status)}>
                    {RefundStatus.getName(item.status)}
                  </span>
                </td>
                <td>
                  {StringHelper.asDateStringToDisplayDateTimeFormat(
                    item.updatedOn
                  )}
                </td>
                <td>
                  {StringHelper.asDateStringToDisplayDateTimeFormat(
                    item.createdOn
                  )}
                </td>
              </tr>
            ))}
        </tbody>
      </>
    );
  }

  async componentDidMount() {
    await RestClient.sendGetRequest(
      this.getApiPath() + "/statistic",
      (response) => {
        this.setState({
          statistic: response,
        });
      },
      this.handleError
    );
    await super.componentDidMount();
  }

  injectSearchTerm(queryParameters, searchBy) {
    return super.injectSearchTerm(
      queryParameters,
      this.createSearchParameters()
    );
  }

  generateExtendedComponents() {
    return (
      <>
        {this.generateStatisticComponent()}
        {this.generateSearchComponent()}
      </>
    );
  }

  generateSearchComponent() {
    return (
      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-body card-block text-left pending-approved">
              <div className="row mb-2">
                <div className="col text-nowrap" style={{ flexGrow: "0" }}>
                  <label className="form-control-label" htmlFor="TransStatus">
                    Refund Status:
                  </label>
                </div>
                <div className="col-md-3 mr-auto">
                  <div
                    className="rs-select2--dark rs-select2--md m-r-10 rs-select2--border"
                    style={{ width: "100%" }}
                  >
                    <select
                      className="form-control"
                      name="search"
                      onChange={(e) => this.onChangeStatus(e)}
                      required
                    >
                      <option value="">All Status</option>
                      {RefundStatus.All.map((x) => (
                        <option value={x.value} key={x.value}>
                          {x.name}
                        </option>
                      ))}
                    </select>
                    <div className="dropDownSelect2" />
                  </div>
                </div>
                <div className="col-md-6 d-flex">
                  <input
                    className="form-control search flex-fill"
                    type="Text"
                    placeholder="Enter transaction number"
                    onChange={(e) => (this.searchText = e.target.value)}
                    onKeyDown={this.onKeyDownSearchInput}
                  />
                  <button
                    className="btn btn-primary search"
                    onClick={this.search}
                  >
                    <i className="fas fa-search" aria-hidden="true" /> Search
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  generateStatisticComponent() {
    const { statistic } = this.state;
    return (
      <div className="row">
        <div className="col-md-3">
          <div className="statistic__item">
            <h2 className="number">{statistic.pending}</h2>
            <span className="desc">Pending Refunds</span>
          </div>
        </div>
        <div className="col-md-3">
          <div className="statistic__item">
            <h2 className="number">{statistic.approved}</h2>
            <span className="desc">Approved Refunds</span>
          </div>
        </div>
        <div className="col-md-3">
          <div className="statistic__item">
            <h2 className="number">{statistic.rejected}</h2>
            <span className="desc">Rejected Refunds</span>
          </div>
        </div>
        <div className="col-md-3">
          <div className="statistic__item">
            <h2 className="number">
              {statistic.successful + statistic.processed + statistic.submitted}
            </h2>
            <span className="desc">Completed Refunds</span>
          </div>
        </div>
      </div>
    );
  }

  getStatusStyle(status) {
    const map = {
      pending: "color-orange",
      rejected: "color-red",
    };
    const statusName = RefundStatus.getName(status);
    if (!statusName) {
      return "color-gray";
    }
    let normalizedStatus = statusName.toLowerCase();
    return map[normalizedStatus] ? map[normalizedStatus] : "color-green";
  }

  onChangeStatus = (e) => {
    const value = e.target.value;
    if (!value) {
      this.selectedStatuses = [
        RefundStatus.Pending,
        RefundStatus.Approved,
        RefundStatus.SubmittedToBank,
        RefundStatus.Successful,
        RefundStatus.Processed,
        RefundStatus.Rejected,
        RefundStatus.Issued,
        RefundStatus.Voided,
      ];
    } else {
      this.selectedStatuses = [+value];
    }
  };

  createStatusFiltering() {
    if (this.selectedStatuses.length === 0) return null;
    return this.selectedStatuses.join(",");
  }

  createSearchParameters() {
    const result = {};
    if (!_.isEmpty(this.searchText)) {
      result.referenceNumber = this.searchText;
    }
    let statuses = this.createStatusFiltering();
    if (!_.isEmpty(statuses)) {
      result.status = statuses;
    }
    return result;
  }
}
